import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

import { getError } from '@/utils/hookFormUtils';

interface AdditionalOptionsProps {
  register: any;
  errors: any;
  checkName: string;
  checkLabel: string;
  inputName: string;
  description: React.ReactNode;
  isChecked?: boolean;
  checkboxChange: () => void;
  disabled: boolean;
}

const AdditionalOptions = ({
  register,
  errors,
  checkName,
  checkLabel,
  inputName,
  description,
  isChecked,
  checkboxChange,
  disabled,
}: AdditionalOptionsProps) => {
  const error = getError(errors, inputName);
  return (
    <Grid>
      <FormControlLabel
        disabled={disabled}
        control={
          <Checkbox
            onChange={checkboxChange}
            name={checkName}
            color="primary"
            checked={isChecked}
          />
        }
        label={checkLabel}
      />
      {isChecked && !disabled && (
        <Grid container spacing={2} size={{ xxs: 12 }}>
          <Grid size={{ xxs: 4 }}>
            <TextField
              {...register(inputName)}
              type="number"
              size="small"
              variant="outlined"
              fullWidth
              placeholder="0"
              error={!!error}
              helperText={error?.message}
              slotProps={{
                htmlInput: {
                  autoComplete: 'off',
                  role: 'presentation',
                },
                input: {
                  onFocus: (e: any) => {
                    if (e.target.value === '0') {
                      e.target.value = '';
                    }
                  },
                  onBlur: (e: any) => {
                    if (e.target.value === '') {
                      e.target.value = '0';
                    } else if (Number(e.target.value) < 0) {
                      e.target.value = '0';
                    }
                  },
                  autoFocus: true,
                },
              }}
            />
          </Grid>
          <Grid size={{ xxs: 12 }} sx={{ '&& span': { color: '#85C440', fontWeight: 'bold' } }}>
            {description}
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default AdditionalOptions;
